export default {
    props: {
        tooltipEnabled: {
            type: Boolean,
            kComposite: 'tooltip.enabled'
        }, 
        tooltipFormat: {
            type: String,
            kComposite: 'tooltip.format'
        }, 
        tooltipTemplate: {
            type: String,
            kComposite: 'tooltip.template'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-inputs-vue-wrapper/src/Common/Tooltip.js